import { takeEvery } from 'redux-saga/effects';
import { CRUD_DELETE_SUCCESS } from 'react-admin';

export default function* deleteSaga() {
  yield takeEvery(CRUD_DELETE_SUCCESS, function* () {
    yield window.location.reload()
  })
}